
import { UserRole, User, Announcement, MaintenanceTicket, Vote, CalendarEvent, Building, ResidentUnit, UnitType } from './types';

export const MOCK_BUILDINGS: Building[] = [
  {
    id: 'b-1',
    name: 'Зграда А1 - Центар',
    address: 'Ул. Македонија бр. 12, Скопје',
    apartmentCount: 24,
    managerName: 'Петар Петровски',
    managerEmail: 'manager@civichome.mk'
  }
];

export const MOCK_RESIDENTS: ResidentUnit[] = [
  {
    id: 'r-1',
    unitNumber: '1',
    floor: '1',
    type: UnitType.RESIDENTIAL,
    isOccupied: true,
    isRented: false,
    tenantName: 'Игор Стефановски',
    tenantEmail: 'igor@email.com',
    tenantPhone: '070 111 222',
    ownerName: 'Игор Стефановски',
    history: []
  },
  {
    id: 'r-2',
    unitNumber: '2',
    floor: '1',
    type: UnitType.BUSINESS,
    isOccupied: true,
    isRented: true,
    tenantName: 'Адвокатска Канцеларија "Правда"',
    tenantEmail: 'pravda@office.mk',
    tenantPhone: '071 333 444',
    ownerName: 'Марија Јовановска',
    history: []
  },
  {
    id: 'r-3',
    unitNumber: '3',
    floor: '2',
    type: UnitType.RESIDENTIAL,
    isOccupied: false,
    isRented: false,
    tenantName: '-',
    tenantEmail: '',
    tenantPhone: '',
    ownerName: 'Дарко Митев',
    history: []
  }
];

export const MOCK_ANNOUNCEMENTS: Announcement[] = [
  {
    id: 'a-1',
    title: 'Итно исклучување на вода',
    content: 'Поради дефект на главната цевка, водата ќе биде исклучена денес од 14:00 до 17:00 часот. Ве молиме за разбирање.',
    author: 'Петар Петровски',
    date: '2024-05-20',
    category: 'Итно'
  },
  {
    id: 'a-2',
    title: 'Редовен состанок на куќен совет',
    content: 'Ве покануваме на редовниот месечен состанок кој ќе се одржи во петок во заедничката просторија. Дневен ред: Чистење на влезот и поправка на лифтот.',
    author: 'Марија Јовановска',
    date: '2024-05-18',
    category: 'Состанок'
  }
];

export const MOCK_TICKETS: MaintenanceTicket[] = [
  {
    id: 'T-101',
    ownerId: 'r-1',
    ownerName: 'Игор Стефановски',
    apartment: '1',
    issue: 'Прегорена сијалица во ходникот на 1-ви кат.',
    status: 'PENDING',
    priority: 'LOW',
    createdAt: '2024-05-19T10:00:00Z',
    dueDate: '2024-05-22',
    history: [
      { id: 'h1', timestamp: '2024-05-19T10:00:00Z', status: 'PENDING', changedBy: 'Игор Стефановски', comment: 'Пријавено.' }
    ]
  },
  {
    id: 'T-102',
    ownerId: 'r-2',
    ownerName: 'Адвокат "Правда"',
    apartment: '2',
    issue: 'Лифтот заглавува помеѓу 2-ри и 3-ти кат.',
    status: 'IN_PROGRESS',
    priority: 'HIGH',
    createdAt: '2024-05-20T08:30:00Z',
    dueDate: '2024-05-21',
    history: [
      { id: 'h2', timestamp: '2024-05-20T09:00:00Z', status: 'IN_PROGRESS', changedBy: 'Администратор', comment: 'Испратена екипа од Компанијата за лифтови.' }
    ]
  }
];

export const MOCK_VOTES: Vote[] = [
  {
    id: 'v-1',
    question: 'Дали се согласувате да се постават соларни панели на кровот за заедничката електрична енергија?',
    options: ['Да', 'Не', 'Потребна ми е повеќе инфо'],
    results: { 'Да': 12, 'Не': 2, 'Потребна ми е повеќе инфо': 4 },
    expiresAt: '2024-06-01',
    votedBy: []
  }
];

export const MOCK_EVENTS: CalendarEvent[] = [
  {
    id: 'e-1',
    title: 'Генерално чистење на зграда',
    date: '2024-05-25',
    time: '09:00',
    type: 'ОДРЖУВАЊЕ',
    description: 'Ангажирана е фирма за длабинско чистење на ходниците и стаклата.'
  }
];

export const MOCK_USERS: Record<string, User> = {
  'admin': {
    id: 'u-admin',
    name: 'Петар Петровски',
    email: 'admin@civichome.mk',
    role: UserRole.PRESIDENT
  },
  'tenant': {
    id: 'u-tenant',
    name: 'Игор Стефановски',
    email: 'igor@email.com',
    role: UserRole.TENANT,
    apartment: '1'
  },
  'maintenance': {
    id: 'u-maint',
    name: 'Зоран Техничар',
    email: 'service@maintenance.mk',
    role: UserRole.MAINTENANCE_STAFF
  },
  'super': {
    id: 'u-super',
    name: 'Супер Корисник',
    email: 'root@civichome.mk',
    role: UserRole.SUPER_ADMIN
  }
};
